import applyIndex from '@/views/doorHelp/applyIndex'
import applyTips from '@/views/doorHelp/applyTips'
import payApply from '@/views/doorHelp/payApply'
import applyDetail from '@/views/doorHelp/applyDetail'
import applySuccess from '@/views/doorHelp/applySuccess'
import unAccept from '@/views/doorHelp/unAccept'
import applyThird from '@/views/doorHelp/applyThird'


export default [
  {
    path: '/applyIndex',
    name: 'applyIndex',
    component: applyIndex,
    meta: {
      title: '门诊预约',
      requireAuth: false,
      requireUserInfo: true
    },
  },


  // 预约提示
  {
    path: '/applyTips',
    name: 'applyTips',
    component: applyTips,
    meta: {
      title: '预约提示',
      requireAuth: false,
    }
  },
  // 支付定金页面
  {
    path: '/payApply',
    name: 'payApply',
    component: payApply,
    meta: {
      title: '门诊预约',
      requireAuth: false,
    }
  },
  // 预约详情页面（可取消预约）
  {
    path: '/applyDetail',
    name: 'applyDetail',
    component: applyDetail,
    meta: {
      title: '预约信息',
      requireAuth: false,
    }
  },
  // 预约成功
  {
    path: '/applySuccess',
    name: 'applySuccess',
    component: applySuccess,
    meta: {
      title: '预约成功',
      requireAuth: false,
    }
  },
  // 未接受该病人页面
  {
    path: '/unAccept',
    name: 'unAccept',
    component: unAccept,
    meta: {
      title: '预约信息',
      requireAuth: false,
    }
  },
  // 今日预约满3次
  {
    path: '/applyThird',
    name: 'applyThird',
    component: applyThird,
    meta: {
      title: '预约信息',
      requireAuth: false,
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/doorHelp.js